import cartActions from '../../../../../pages/vip/features/cart-actions/cart-actions.mobile';

export default cartActions;
